import React from 'react';
import { connect } from 'react-redux';

import wrapMain from '../../wrap-main';

import Table from '../../../shared/new-table/main';
import table from './table-initial-data';

function CampaignList({ rows }) {
	return (
		<Table table={table} rows={rows} />
	);
}

function mapStateToProps(state) {
	return {
		rows: state.root.lists['popup-campaigns']
	};
}

export default connect(mapStateToProps)(wrapMain(CampaignList));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/campaigns/list/main.js